import React, { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    const links = [
        { id: "home", label: "Home" },
        { id: "services", label: "Services" },
        { id: "testimony", label: "Testimony" },
        { id: "contact", label: "Contact Us" },
    ];

    const scrollTo = (id: string) => {
        if (location.pathname !== "/") {
            // Navigate home with hash
            navigate(`/#${id}`);
        } else {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }
        setOpen(false);
    };

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
            }, 100); // small delay ensures DOM is rendered
        }
    }, [location]);

    return (
        <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
            <div className="nav-container">
                {/* Hamburger (left) */}
                <div className="hamburger" onClick={() => setOpen(!open)}>
                    ☰
                </div>
                {/* onClick={() => navigate("/services")} */}
                {/* Centered Menu */}
                <ul className="nav-links">
                    {links.map((link) => (
                        <li key={link.id} onClick={() => link.id === 'services' ? navigate("/services") : scrollTo(link.id)}>
                            {link.label}
                        </li>
                    ))}
                </ul>

                {/* Social Icons (right) */}
                <div className="social-icons">
                    <a href="https://www.facebook.com/share/19jkGxqGyB/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                        <FaFacebookF />
                    </a>
                    <a href="https://www.instagram.com/cedarwoodspawellness?igsh=N3MxODUxNTIwZXM1" target="_blank" rel="noreferrer">
                        <FaInstagram />
                    </a>
                    {/* <a href="https://twitter.com" target="_blank" rel="noreferrer">
                        <FaTwitter />
                    </a> */}
                </div>
            </div>

            {/* Mobile Menu */}
            {open && (
                <ul className="mobile-menu">
                    {links.map((link) => (
                        <li
                            key={link.id}
                            onClick={() => {
                                if (link.id === "services") {
                                    navigate("/services");
                                } else {
                                    scrollTo(link.id);
                                }
                                setOpen(false); // close the mobile menu in both cases
                            }}
                        >
                            {link.label}
                        </li>
                    ))}
                </ul>
            )}
        </nav>
    );
};

export default Navbar;
